<template>
  <div v-if="isLoggedIn" class="floating-button-container">
    <!-- 向导按钮 -->
    <button 
      class="floating-button" 
      @click="handleClick"
      :title="buttonTitle"
      aria-label="DIVA 智能客服"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" fill="currentColor"/>
      </svg>
      <span class="button-text">{{ t('user_guide') }}</span>
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { STATIC_URL } from '@/config/config.js';

export default {
  name: 'FloatingButton',
  props: {
    buttonTitle: {
      type: String,
      default: 'DIVA 智能客服'
    }
  },
  setup() {
    const { t } = useI18n();
    const authStore = useAuthStore();

    // 检查用户是否已登录
    const isLoggedIn = computed(() => authStore.isAuthenticated);

    return {
      t,
      isLoggedIn
    }
  },
  methods: {
    handleClick(event) {
      // 防止事件冒泡
      event.preventDefault();
      event.stopPropagation();
      
      // 打开 workbrain 链接
      const workbrainUrl = 'https://workbrain.cn/room/#/showRoom?applyId=11559102357431045&language=zh_CN';
      window.open(workbrainUrl, '_blank');
      
      // 发射事件，保持原有功能
      this.$emit('click', event);
    }
  }
}
</script>

<style scoped>
.floating-button-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.floating-button {
  width: auto;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.floating-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  background: linear-gradient(135deg, var(--color-primary-hover) 0%, var(--color-primary-dark-hover) 100%);
}

.floating-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.floating-button svg {
  transition: transform 0.2s ease;
  color: white;
  flex-shrink: 0;
}

.button-text {
  color: white;
  font-weight: 500;
}

.floating-button:hover svg {
  transform: scale(1.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-button-container {
    bottom: 20px;
    right: 20px;
    gap: 8px;
  }
  
  .floating-button {
    height: 44px;
    padding: 0 12px;
    font-size: 13px;
  }
  
  .floating-button svg {
    width: 20px;
    height: 20px;
  }
}

/* 确保按钮不会被其他元素遮挡，特别是在仪表板布局中 */
.floating-button-container {
  pointer-events: auto;
  z-index: 9999; /* 提高z-index确保在所有内容之上 */
}

/* 避免与侧边栏冲突 */
@media (min-width: 769px) {
  .floating-button-container {
    right: 24px; /* 在桌面端保持右侧距离 */
  }
}

/* 在移动端避免与移动端菜单按钮冲突 */
@media (max-width: 768px) {
  .floating-button-container {
    right: 20px;
  }
}

/* 动画效果 */
@keyframes float-in {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.floating-button {
  animation: float-in 0.3s ease-out;
}
</style>